// extracted by mini-css-extract-plugin
module.exports = {"formSpace":"styles_formSpace__1Mcvc"};